<template>
  <div class="content">
    <p class="title">
      {{ survey.title }}
      <span v-if="survey.closed"> ({{ $t("surveyClosed") }}) </span>
    </p>
    <div v-if="hasSurvey && hasAnswers">
      <div v-for="(question, key) in survey.questions" :key="key" class="mt-4">
        <b-collapse v-if="Object.keys(question).length > 0" class="card" :open="false">
          <div slot="trigger" class="card-header">
            <span class="card-header-title">{{
              question.question + ", " + $t("numberOfVotes") + ": " + all_answers[key].votes
            }}</span>
            <a class="card-header-icon">
              <b-icon icon="checkbox-blank-circle" :type="key == survey.currentQuestion ? 'is-danger' : 'is-black'" />
            </a>
          </div>
          <div class="card-content">
            <div v-if="question.type == 'surveySelect' || question.type == 'surveySimple'">
              <!--<div 
                v-for="(option, key2) in question.options"
                :key="key2"
              >
                <b-field 
                  v-if="hasAnswers" 
                  :label="option.text"
                >
                  <b-progress 
                    type="is-info"
                    show-value
                    :value="all_answers[key][key2] / all_answers[key].total * 100"
                  >
                    <span class="has-text-black">
                      {{ Math.floor( all_answers[key][key2] ) }}
                    </span>
                  </b-progress>
                </b-field>
              </div>-->
              <div class="columns">
                <div class="mb-4 column">
                  <div v-for="(option, key2) in question.options" :key="key2">
                    <li>
                      <b>{{ option.text }}</b
                      >, ({{ all_answers[key][key2] }}
                      <span v-if="all_answers[key][key2] == 1">{{ $t("votesSingular") }}</span
                      ><span v-else>{{ $t("votes") }}</span
                      ><span v-if="all_answers[key].total"
                        >, {{ (all_answers[key][key2] / all_answers[key].total).toFixed(2) * 100 }}%</span
                      >)
                    </li>
                  </div>
                  <li v-if="question.abstain">
                    <b>{{ $t("abstains") }}</b
                    >, ({{ all_answers[key].abstains }} {{ $t("participants") }})
                  </li>
                </div>
                <div class="column" style="max-width: 300px">
                  <div v-if="all_answers[key].total > 0" style="" class="">
                    <RenderResults :question="question" :responses="all_answers[key]" :server-answer="{}" />
                  </div>
                </div>
              </div>

              <p>
                {{ $t("selectable") + ": " + question.selectable }}
              </p>
              <p>{{ $t("participants") }}: {{ all_answers[key].votes }}</p>
              <p v-if="!question.abstain">
                {{ $t("abstainsNotAllowed") }}
              </p>
              <p v-if="question.timed">{{ $t("timed") }}: {{ question.duration }}s</p>
              <p v-else>
                {{ $t("questionNotTimed") }}
              </p>
              <p v-if="question.showResults">
                {{ $t("questionShowResults") }}
              </p>
              <p v-else-if="question.onlyFinalResults">
                {{ $t("questionOnlyFinalResults") }}
              </p>
              <p v-else>
                {{ $t("questionNotShowResults") }}
              </p>
            </div>
            <b-field group-multiline grouped>
              <b-button
                class="mt-4 control"
                :loading="isLoading"
                :disabled="isDisabled || survey.closed"
                :style="key == survey.currentQuestion ? 'color:#FF0082; border-color:#FF0082' : ''"
                @click.native="
                  key == survey.currentQuestion ? setStatus(key, 'closeQuestion') : setStatus(key, 'openQuestion')
                "
              >
                <span v-if="key == survey.currentQuestion">LIVE</span>
                <span v-else>{{ $t("setLive") }}</span>
              </b-button>
              <b-button
                v-if="key == survey.currentQuestion"
                class="mt-4 control"
                :loading="isLoading"
                :disabled="isDisabled"
                :style="question.closed ? 'color:#0F9D58; border-color:#0F9D58' : ''"
                @click="question.closed ? setStatus(key, 'startVote') : setStatus(key, 'stopVote')"
              >
                <span v-if="question.closed == true">{{ $t("openVote") }}</span>
                <span v-else>{{ $t("closeVote") }}</span>
              </b-button>
              <b-button
                v-if="key != survey.currentQuestion"
                type="is-info"
                class="mt-4 control"
                :loading="isLoading"
                :disabled="isDisabled || survey.closed"
                icon-left="pencil-outline"
                @click="
                  modalQuestion = cloneDeep(question);
                  modalQuestionKey = key;
                  questionModalActive = true;
                "
              />
            </b-field>
            <div v-if="question.timed && key == survey.currentQuestion">
              <b-progress
                class="mt-4"
                :type="questionProgress < 50 ? 'is-success' : questionProgress < 80 ? 'is-warning' : 'is-danger'"
                :value="questionProgress"
                show-value
              >
                <span v-if="questionProgress < 100 && !question.closed" class="has-text-black">
                  {{
                    Math.floor(
                      question.duration - Math.abs(question.open_time.toDate().getTime() - new Date().getTime()) / 1000,
                    )
                  }}s
                </span>
                <span v-else class="has-text-black">
                  {{ $t("closed") }}
                </span>
              </b-progress>
            </div>
          </div>
        </b-collapse>
      </div>
      <!--<b-collapse
        v-if="!survey.closed"
        class="card mt-4"
        :open="false"
      >
        <div 
          slot="trigger" 
          class="card-header" 
        >
          <span class="card-header-title">{{ $t('addQuestion') }}</span>
          <a class="card-header-icon">
            <b-icon 
              icon="plus"
              type="is-black" 
            />
          </a>
        </div>
        <div 
          class="card-content"
        >
          <EditQuestion 
            :question-key="modalQuestionKey"
            :question="modalQuestion"
            :questions="survey.questions"
            :quick="true"
            :modal="false"
            :survey-id="survey.id"
          />
          <b-button
            @click="setNewQuestion()"
          />
        </div>
      </b-collapse>-->
      <b-collapse v-if="!survey.closed && survey.options.personalization" class="card mt-4" :open="false">
        <div slot="trigger" class="card-header">
          <span class="card-header-title">{{ $t("participants") }}</span>
          <a class="card-header-icon">
            <b-icon icon="account-outline" type="is-black" />
          </a>
        </div>
        <div class="card-content">
          <Personalization :edit="false" />
        </div>
      </b-collapse>
    </div>
    <b-field group-multiline grouped>
      <b-dropdown aria-role="list" class="control" position="is-top-right">
        <b-button
          slot="trigger"
          slot-scope="{ active }"
          class="mt-4 control"
          :icon-left="active ? 'menu-up' : 'plus'"
          type="is-info"
          :disabled="isDisabled || survey.closed"
        >
          {{ $t("addQuestion") }}
        </b-button>

        <b-dropdown-item aria-role="listitem" @click="setNewQuestion('surveySelect')">
          <span class=""
            ><b>{{ $t("addSelectQuestion") }}</b></span
          >
        </b-dropdown-item>
        <b-dropdown-item aria-role="listitem" @click="setNewQuestion('surveySimple')">
          <span class=""
            ><b>{{ $t("addYesNoQuestion") }}</b></span
          >
        </b-dropdown-item>
      </b-dropdown>
      <b-button
        class="mt-4 control"
        type="is-primary"
        icon-left="checkbox-multiple-blank-outline"
        :loading="isLoading"
        :disabled="isDisabled || survey.closed"
        @click="modalActive = true"
      >
        {{ $t("surveyLinks") }}
      </b-button>
      <b-button
        class="mt-4 control"
        type="is-primary"
        icon-left="download"
        :loading="isLoading"
        :disabled="isDisabled"
        @click="exportResults"
      >
        {{ $t("exportResults") }}
      </b-button>
      <!--<b-button 
        class="mt-4 control"
        type="is-primary"
        icon-left="presentation"
        :loading="isLoading"
        :disabled="isDisabled"
        @click="goToPresentation"
      > 
        {{ $t('goToPresentation') }}
      </b-button>
      <b-button 
        class="mt-4 control"
        type="is-primary"
        icon-left="stop"
        :loading="isLoading"
        :disabled="isDisabled || survey.closed"
        @click="closeSurvey"
      > 
        {{ $t('closeSurvey') }}
      </b-button>-->
    </b-field>
    <b-modal
      :active.sync="modalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="false"
      aria-role="dialog"
      aria-modal
    >
      <AdminLinks :survey-code="$route.params.surveyCode" :survey-id="survey.id" />
    </b-modal>
    <b-modal
      :active.sync="questionModalActive"
      has-modal-card
      trap-focus
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
    >
      <EditQuestion
        :question-key="modalQuestionKey"
        :question="modalQuestion"
        :questions="survey.questions"
        :quick="true"
        :modal="true"
        :survey-id="survey.id"
      />
    </b-modal>
  </div>
</template>

<script>
import { db, functions } from "@/firebase";
import RenderResults from "./RenderResults";
import AdminLinks from "./AdminLinks";
import Personalization from "./Personalization";
import moment from "moment";
import EditQuestion from "./EditQuestion";
import cloneDeep from "clone-deep";

export default {
  name: "SurveyAdminQuestions",
  components: {
    RenderResults,
    AdminLinks,
    Personalization,
    EditQuestion,
  },
  props: {
    survey: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      isLoading: false,
      isDisabled: false,
      all_answers: null,
      questionProgress: 100,
      interval: null,
      loaded: false,
      loadOnce: true,
      modalActive: false,
      questionModalActive: false,
      modalQuestion: {},
      modalQuestionKey: 0,
      cloneDeep,
      sampleQuestions: {
        surveySelect: {
          type: "surveySelect",
          question: "",
          options: [{ text: "" }, { text: "" }],
          selectable: 1,
          closed: false,
          duration: 60,
          timed: false,
          personalization: false,
          showResults: true,
          onlyFinalResults: false,
          abstain: true,
          showAbstainBig: false,
        },
        surveySimple: {
          type: "surveySimple",
          question: "",
          options: [{ text: "Ja" }, { text: "Nein" }],
          selectable: 1,
          closed: false,
          duration: 60,
          timed: false,
          personalization: false,
          showResults: true,
          onlyFinalResults: false,
          abstain: true,
          showAbstainBig: false,
        },
      },
    };
  },
  computed: {
    currentQuestion() {
      if (this.hasSurvey) {
        return this.survey.questions[this.survey.currentQuestion];
      }
      return {};
    },
    hasSurvey() {
      return this.survey != null && Object.keys(this.survey).length != 0;
    },
    hasAnswers() {
      return this.all_answers != null && Object.keys(this.all_answers).length != 0;
    },
  },
  watch: {
    survey: {
      immediate: true,
      handler() {
        if (this.hasSurvey) {
          this.$store.commit("LOAD_SURVEY_DATA", this.survey);
          if (this.loadOnce) {
            this.$bind("all_answers", db.collection("surveys").doc(this.survey.id).collection("answers"));
            this.loadOnce = false;
          }
          if (this.currentQuestion) {
            this.startTimer();
          }
        }
      },
    },
  },
  methods: {
    setNewQuestion(questionType = "surveySelect") {
      this.modalQuestion = cloneDeep(this.sampleQuestions[questionType]);
      this.modalQuestionKey = this.survey.questions.length;
      this.questionModalActive = true;
    },
    startTimer() {
      this.checkProgress();
      this.interval = setInterval(this.checkProgress, 700);
    },
    checkProgress() {
      let question = this.currentQuestion;
      if (question.timed && this.currentQuestion) {
        this.questionProgress =
          (Math.abs(question.open_time.toDate().getTime() - new Date().getTime()) / 1000 / question.duration) * 100;
        if (this.questionProgress >= 100) {
          this.questionProgress = 100;
          clearInterval(this.interval);
        }
        if (question.closed) {
          this.questionProgress = 100;
          clearInterval(this.interval);
        }
        return;
      }
      clearInterval(this.interval);
    },
    async setStatus(id, status) {
      this.isLoading = true;
      this.isDisabled = true;
      try {
        await functions.httpsCallable("SetSurveyQuestionStatus")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
          questionIndex: id,
          status: status,
        });
        if (status == "openQuestion" || status == "startVote") {
          this.startTimer();
        } else if (status == "closeQuestion" || status == "stopVote") {
          clearInterval(this.interval);
        }
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    downloadCSV(data, title) {
      var blob = new Blob([data], { type: "text/csv" });
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveBlob(blob, `${title}.csv`);
      } else {
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = `${title}.csv`;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
      }
    },
    async exportResults() {
      this.isLoading = true;
      this.isDisabled = true;
      try {
        let result = await functions.httpsCallable("GenerateCSVSurveyExport")({
          moderationPw: this.$route.params.moderationPw,
          surveyId: this.survey.id,
        });
        this.downloadCSV(result.data[0], this.$t("surveyResults") + "_" + moment().format("DD-MM-YYYY"));
        if (result.data[1]) {
          this.downloadCSV(result.data[1], this.$t("surveyUserResults") + "_" + moment().format("DD-MM-YYYY"));
        }
      } finally {
        this.isLoading = false;
        this.isDisabled = false;
      }
    },
    async closeSurvey() {
      this.$buefy.dialog.confirm({
        title: this.$t("closeSurvey"),
        message: this.$t("closeSurveyInfo"),
        confirmText: this.$t("closeSurvey"),
        cancelText: this.$t("cancel"),
        type: "is-danger",
        closeOnConfirm: true,
        hasIcon: true,
        onConfirm: async (value, component) => {
          this.isLoading = true;
          this.isDisabled = true;
          try {
            await functions.httpsCallable("SetSurveyQuestionStatus")({
              moderationPw: this.$route.params.moderationPw,
              surveyId: this.survey.id,
              questionIndex: 0,
              status: "closeSurvey",
            });
            this.$buefy.toast.open({
              type: "is-success",
              message: this.$t("surveyClosed"),
            });
          } finally {
            this.isLoading = false;
            this.isDisabled = false;
          }
          component.close();
        },
      });
    },
    goToPresentation() {
      this.$router.push({
        name: "SurveyPresentation",
        params: {
          surveyId: this.survey.id,
          moderationPw: this.$route.params.moderationPw,
        },
      });
    },
    checkValidity() {},
    async deleteQuestion(key) {
      let question = this.survey.questions[key];
      this.$buefy.dialog.confirm({
        title: this.$t("deleteQuestion"),
        message: this.$t("deleteQuestionInfo") + ' "' + question.question + '" ',
        confirmText: this.$t("deleteQuestion"),
        cancelText: this.$t("cancel"),
        type: "is-danger",
        closeOnConfirm: true,
        hasIcon: true,
        onConfirm: async (value, component) => {
          try {
            this.isDisabled = true;
            this.isLoading = true;
            console.log(this.survey.id, key, this.$route.params.moderationPw);
            await functions.httpsCallable("DeleteSurveyQuestion")({
              surveyId: this.survey.id,
              moderationPw: this.$route.params.moderationPw,
              questionKey: key,
            });
            this.$buefy.toast.open({
              message: this.$t("questionDeleted"),
              type: "is-success",
            });
          } catch (_error) {
            this.$buefy.toast.open({
              message: this.$t("questionCouldNotBeDeleted"),
              type: "is-danger",
            });
          } finally {
            this.isDisabled = false;
            this.isLoading = false;
            component.close();
          }
        },
      });
    },
  },
};
</script>

<style></style>
